var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "159.000000pt",
    height: "158.000000pt",
    viewBox: "0 0 159.000000 158.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,158.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728 1284 c-56 -30 -58 -44 -58 -389 0 -270 2 -316 15 -321 9 -4 43 15 83 44 l68 51 202 3 202 3 27 28 28 27 3 240 c4 346 20 330 -315 330 -182 -1 -234 -4 -255 -16z m497 -59 c25 -24 25 -24 25 -240 0 -286 20 -265 -243 -265 l-193 0 -40 -30 c-21 -16 -42 -30 -46 -30 -5 0 -8 122 -8 270 l0 271 25 24 c24 25 24 25 240 25 216 0 216 0 240 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 1134 c-4 -4 -7 -16 -7 -26 0 -17 12 -18 186 -18 l185 0 -3 23 c-3 22 -5 22 -179 25 -96 1 -178 -1 -182 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 1004 c-4 -4 -7 -16 -7 -26 0 -17 12 -18 186 -18 l185 0 -3 23 c-3 22 -5 22 -179 25 -96 1 -178 -1 -182 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 855 l0 -26 103 3 c94 3 102 4 102 23 0 19 -8 20 -102 23 l-103 3 0 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 801 c-93 -42 -120 -146 -60 -233 l23 -35 -33 -33 c-41 -40 -56 -87 -52 -160 l3 -55 179 -3 c193 -3 196 -2 196 50 0 68 -22 130 -60 168 -33 33 -37 40 -24 51 32 26 46 71 42 126 -4 44 -11 60 -38 88 -31 32 -82 55 -120 55 -8 0 -33 -9 -56 -19z m122 -59 c45 -36 55 -85 27 -132 -43 -74 -145 -65 -179 16 -27 64 24 134 96 134 19 0 45 -8 56 -18z m18 -263 c35 -28 56 -70 56 -114 l0 -35 -135 0 -135 0 0 31 c0 45 29 98 64 120 43 26 115 25 150 -2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedStep1);
export default __webpack_public_path__ + "static/media/feed-step-1.9fa801d5a1d55ba53f381f3756d02656.svg";
export { ForwardRef as ReactComponent };